import { c as _c } from "react/compiler-runtime";
import { Menu, MenuItem } from "@flat-ui";
import { FilterChip } from "@components/common/faro-table/faro-table-filter/filter-chip";
import { FilterChipDropdownItem } from "@components/common/faro-table/faro-table-filter/filter-chip-dropdown-item";
import { FilterChipSearch } from "@components/common/faro-table/faro-table-filter/filter-chip-search";
import { useFilterQueryParams } from "@hooks/table-filters/use-filter-query-params";
import { Box } from "@mui-wrapper";
import { useMemo, useState } from "react";
/** A chip to show for grouping set of filters. The children is the content shown after clicking on a chip */
export function DropdownFilterChip(t0) {
  const $ = _c(52);
  const {
    filteredColumn,
    label,
    items,
    shouldShowSearchBox,
    shouldShowCheckbox,
    shouldShowCheckIconOnRight: t1,
    shouldAllowLabelTranslation: t2,
    tableType,
    size: t3
  } = t0;
  const shouldShowCheckIconOnRight = t1 === undefined ? false : t1;
  const shouldAllowLabelTranslation = t2 === undefined ? false : t2;
  const size = t3 === undefined ? "small" : t3;
  const [anchorEl, setAnchorEl] = useState(null);
  const [searchText, setSearchText] = useState("");
  const dropdownWidth = size === "small" ? "230px" : "350px";
  let t4;
  if ($[0] !== items || $[1] !== searchText) {
    const search = searchText.trim().toLowerCase();
    t4 = Object.values(items).filter(item => [item.label, ...(item.searchTerms ?? [])].some(value => value.toLowerCase().includes(search)));
    $[0] = items;
    $[1] = searchText;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const filterItems = t4;
  const {
    getFilterIdsForColumn,
    updateFilterItem
  } = useFilterQueryParams();
  let T0;
  let T1;
  let t10;
  let t11;
  let t12;
  let t13;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[3] !== anchorEl || $[4] !== dropdownWidth || $[5] !== filterItems || $[6] !== filteredColumn || $[7] !== getFilterIdsForColumn || $[8] !== label || $[9] !== searchText || $[10] !== shouldAllowLabelTranslation || $[11] !== shouldShowCheckIconOnRight || $[12] !== shouldShowCheckbox || $[13] !== shouldShowSearchBox || $[14] !== tableType || $[15] !== updateFilterItem) {
    const activeFilterIds = getFilterIdsForColumn(filteredColumn);
    const onOptionClicked = function onOptionClicked(filterId) {
      updateFilterItem({
        tableType,
        filteredColumn,
        filterId,
        shouldReplaceFilterInColumn: !shouldShowCheckbox
      });
      setSearchText("");
    };
    T1 = Box;
    t12 = "div";
    const t14 = !!anchorEl;
    let t15;
    if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
      t15 = event => setAnchorEl(event.currentTarget);
      $[27] = t15;
    } else {
      t15 = $[27];
    }
    if ($[28] !== filteredColumn || $[29] !== label || $[30] !== t14) {
      t13 = <FilterChip filteredColumn={filteredColumn} label={label} shouldHaveDropdown={true} isDropdownOpen={t14} onClick={t15} />;
      $[28] = filteredColumn;
      $[29] = label;
      $[30] = t14;
      $[31] = t13;
    } else {
      t13 = $[31];
    }
    T0 = Menu;
    t5 = anchorEl;
    t6 = !!anchorEl;
    if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = () => setAnchorEl(null);
      $[32] = t7;
    } else {
      t7 = $[32];
    }
    t8 = dropdownWidth;
    if ($[33] !== dropdownWidth) {
      t9 = {
        paper: {
          sx: {
            width: dropdownWidth,
            maxHeight: "330px",
            overflowY: "auto"
          }
        }
      };
      $[33] = dropdownWidth;
      $[34] = t9;
    } else {
      t9 = $[34];
    }
    if ($[35] !== searchText || $[36] !== shouldShowSearchBox) {
      t10 = shouldShowSearchBox && <FilterChipSearch searchText={searchText} setSearchText={setSearchText} onEscape={() => {
        setAnchorEl(null);
        setSearchText("");
      }} />;
      $[35] = searchText;
      $[36] = shouldShowSearchBox;
      $[37] = t10;
    } else {
      t10 = $[37];
    }
    t11 = filterItems.length === 0 ? <MenuItem label={`No ${label.toLowerCase()} found!`} sx={{
      pointerEvents: "none",
      textWrap: "wrap"
    }} /> : filterItems.map(item_0 => <FilterChipDropdownItem key={item_0.id} filterItem={item_0} isItemSelected={activeFilterIds.includes(item_0.id)} onItemClicked={onOptionClicked} shouldShowCheckbox={shouldShowCheckbox} shouldShowCheckIconOnRight={shouldShowCheckIconOnRight} shouldAllowLabelTranslation={shouldAllowLabelTranslation} />);
    $[3] = anchorEl;
    $[4] = dropdownWidth;
    $[5] = filterItems;
    $[6] = filteredColumn;
    $[7] = getFilterIdsForColumn;
    $[8] = label;
    $[9] = searchText;
    $[10] = shouldAllowLabelTranslation;
    $[11] = shouldShowCheckIconOnRight;
    $[12] = shouldShowCheckbox;
    $[13] = shouldShowSearchBox;
    $[14] = tableType;
    $[15] = updateFilterItem;
    $[16] = T0;
    $[17] = T1;
    $[18] = t10;
    $[19] = t11;
    $[20] = t12;
    $[21] = t13;
    $[22] = t5;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
  } else {
    T0 = $[16];
    T1 = $[17];
    t10 = $[18];
    t11 = $[19];
    t12 = $[20];
    t13 = $[21];
    t5 = $[22];
    t6 = $[23];
    t7 = $[24];
    t8 = $[25];
    t9 = $[26];
  }
  let t14;
  if ($[38] !== T0 || $[39] !== t10 || $[40] !== t11 || $[41] !== t5 || $[42] !== t6 || $[43] !== t7 || $[44] !== t8 || $[45] !== t9) {
    t14 = <T0 anchorEl={t5} open={t6} onClose={t7} minWidth={t8} slotProps={t9}>{t10}{t11}</T0>;
    $[38] = T0;
    $[39] = t10;
    $[40] = t11;
    $[41] = t5;
    $[42] = t6;
    $[43] = t7;
    $[44] = t8;
    $[45] = t9;
    $[46] = t14;
  } else {
    t14 = $[46];
  }
  let t15;
  if ($[47] !== T1 || $[48] !== t12 || $[49] !== t13 || $[50] !== t14) {
    t15 = <T1 component={t12}>{t13}{t14}</T1>;
    $[47] = T1;
    $[48] = t12;
    $[49] = t13;
    $[50] = t14;
    $[51] = t15;
  } else {
    t15 = $[51];
  }
  return t15;
}